import { Api } from '@axiom/ui';
import type { User, AfcUsersNotificationInline } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UsersApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readUserNotifications(id: User['id']) {
    return super.read<{ data: AfcUsersNotificationInline }>({
      endpoint: `/users/${id}/notifications/inline`,
      method: 'GET',
    });
  }

  async refreshUserNotifications(id: User['id']) {
    return super.invalidate(`/users/${id}/notifications/inline`);
  }

  async createAcknowledgeUserNotifications(
    id: User['id'],
    notificationIds: string[]
  ) {
    return super.write<unknown>({
      endpoint: `/users/${id}/notifications/inline/acknowledge`,
      body: notificationIds,
      method: 'POST',
    });
  }
}

export const UsersApi = new UsersApiClass();
